enum Deals {
  InternalServerError           = "PBDEAInternalServerError",
  DataDeleteError               = "PBDEADataDeleteError",
  DataReadError                 = "PBDEADataReadError",
  DataStoreError                = "PBDEADataStoreError",
  DataUpdateError               = "PBDEADataUpdateError",
  ContentTypeJson               = "PBDEAContentTypeJson",
  InvalidJson                   = "PBDEAInvalidJson",
  InvalidQueryParam             = "PBDEAInvalidQueryParam",
  ResourceChanged               = "PBDEAResourceChanged",
  ResourceNotFound              = "PBDEAResourceNotFound",
  FieldMissing                  = "PBDEAFieldMissing",
  FieldRequired                 = "PBDEAFieldRequired",
  FieldUnexpected               = "PBDEAFieldUnexpected",
  FieldsInvalid                 = "PBDEAFieldsInvalid",
  SearchDeleteError             = "PBDEASearchDeleteError",
  SearchIndexError              = "PBDEASearchIndexError",
  SearchListError               = "PBDEASearchListError",
  FactoryNotSet                 = "PBDEAFactoryNotSet",
  FactoryModeNotSet             = "PBDEAFactoryModeNotSet",
  InvalidPageNumber             = "PBDEAInvalidPageNumber",
  CategoryActiveMenuTrue        = "PBDEACategoryActiveMenuTrue",
  CategoryLocaleInvalid         = "PBDEACategoryLocaleInvalid",
  CategoryNameNotUnique         = "PBDEACategoryNameNotUnique",
  CategoryUrlNotUnique          = "PBDEACategoryUrlNotUnique",
  DealCreateRequiresType        = "PBDEADealCreateRequiresType",
  DealDeliveryHighlightInvalid  = "PBDEADealDeliveryHighlightInvalid",
  DealFilteringGeoError         = "PBDEADealFilteringGeoError",
  DealFilteringLatLngError      = "PBDEADealFilteringLatLngError",
  DealInternalIdNotUnique       = "PBDEADealInternalIdNotUnique",
  DealNotExist                  = "PBDEADealNotExist",
  DealProductHasNoStock         = "PBDEADealProductHasNoStock",
  DealStatusInvalid             = "PBDEADealStatusInvalid",
  DealTypeInvalid               = "PBDEADealTypeInvalid",
  DealTypeHighlightInvalid      = "PBDEADealTypeHighlightInvalid",
  DealUrlSlugNotUnique          = "PBDEADealUrlSlugNotUnique",
  DealUserSavingsInvalid        = "PBDEADealUserSavingsInvalid",
  DealUserSavingsHeaderNotNull  = "PBDEADealUserSavingsHeaderNotNull",
  DealUserSavingsValueNotNull   = "PBDEADealUserSavingsValueNotNull",
  i18nCountryInvalid            = "PBDEAi18nCountryInvalid",
  i18nCurrencyInvalid           = "PBDEAi18nCurrencyInvalid",
  i18nLanguageInvalid           = "PBDEAi18nLanguageInvalid",
  LocaleCannotChange            = "PBDEALocaleCannotChange",
  LocaleInvalid                 = "PBDEALocaleInvalid",
  LocationBatchSizeError        = "PBDEALocationBatchSizeError",
  LocationBodyInvalid           = "PBDEALocationBodyInvalid",
  LocationBodyContentInvalid    = "PBDEALocationBodyContentInvalid",
  MerchantUuidNotUnique         = "PBDEAMerchantUuidNotUnique",
  PdfStoreError                 = "PBDEAPdfStoreError",
  ProductInvalid                = "PBDEAProductInvalid",
  RedemptionDealMissing         = "PBDEARedemptionDealMissing",
  RedemptionDealNotON           = "PBDEARedemptionDealNotON",
  RedemptionItemInvalid         = "PBDEARedemptionItemInvalid",
  RedemptionStatusInvalid       = "PBDEARedemptionStatusInvalid",
  RedemptionUserMissing         = "PBDEARedemptionUserMissing",
  TagNotExist                   = "PBDEATagNotExist",
  RedemptionNotComplete         = "PBDEARedemptionNotComplete",
  TagNameNotUnique              = "PBDEATagNameNotUnique",
  TagUrlNotUnique               = "PBDEATagUrlNotUnique",
  TagLocaleInvalid              = "PBDEATagLocaleInvalid",
  UserNotExist                  = "PBDEAUserNotExist",
  UserCanOnlySaveTurnedOnDeals  = "PBDEAUserCanOnlySaveTurnedOnDeals"
}
export default Deals
